import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store/index';
import { ID } from '@/types/type';

interface IFavoriteListStore {
  idList: ID[];
}

@Module({
  dynamic: true,
  store,
  name: 'favoriteListStore',
  namespaced: true,
})
export default class FavoriteListStore extends VuexModule
  implements IFavoriteListStore {
  public idList: ID[] = [];

  @Mutation
  public setUp(idList: ID[]) {
    this.idList = idList;
  }

  @Mutation
  public add(id: ID) {
    this.idList.push(id);
  }

  @Mutation
  public remove(id: ID) {
    const index = this.idList.indexOf(id);
    if (index > -1) {
      this.idList.splice(index, 1);
    }
  }

  public get menuIdList(): ID[] {
    return this.idList;
  }
}

export const favoriteListModule = getModule(FavoriteListStore);
